import { render, staticRenderFns } from "./CompanyTem.vue?vue&type=template&id=2dcb68da&"
import script from "./CompanyTem.vue?vue&type=script&lang=js&"
export * from "./CompanyTem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports